import { useContext } from "react";
import { CalendarContext, CalendarContextType } from "../contexts/calendar";

export function useCalendar(): CalendarContextType {
    const context = useContext(CalendarContext);
    if (!context) {
        throw new Error('useCalendar deve ser usado dentro de um CalendarProvider');
    }
    return context;
}